__webpack_require__.p = "https://curation-app.talktomeinkorean.com/";